import React from 'react'
import { NavLink as Link  } from "react-router-dom"
import { useMediaQuery } from '../hooks/MediaQuery'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCalendarAlt,
  faHome,
  faChartBar,
  faSignOutAlt,
  faUser,
  faListAlt,
  faHdd
} from '@fortawesome/free-solid-svg-icons'

const itemStyle = {
  borderRadius: 0
}

const activeItemStyle = {
  color: "#fff",
  borderRadius: 0,
  borderBottom: 3,
  borderBottomStyle: "solid"
}

const mediumItemStyle = {
  paddingBottom: 6,
  borderRadius: 0,
  margin: "-0.8em 0 -1.5em 0"
}

const mediumActiveItemStyle = {
  paddingBottom: 6,
  borderRadius: 0,
  margin: "-0.8em 0 -1.5em 0",
  borderBottom: 3,
  borderBottomStyle: "solid",
  color: "#fff"
}

const bigItemStyle = {
  borderRadius: 0,
  margin: "-0.8em -4px -0.8em -4px"
}

const bigActiveItemStyle = {
  color: "#fff",
  borderRadius: 0,
  borderBottom: 3,
  borderBottomStyle: "solid",
  margin: "-0.8em -4px -0.8em -4px",
  backgroundColor: "#ffffff2c"
}

const Item = ({icon, children}) => {
  return (
    <div>
      <FontAwesomeIcon icon={icon}/>
      <span className="d-none d-xl-inline-block px-1">{children}</span>
    </div>
  )
}

export default function Header({ user, signout }) {
  const isSuperuser = user && user.is_superuser
  const isMediumScreen = useMediaQuery("(min-width: 992px)")
  const isBigScreen = useMediaQuery("(min-width: 1200px)")
  const activeClassName = navData => navData.isActive ? "nav-link active" : "nav-link"
  let activeStyle = null
  if (isBigScreen) {
    activeStyle = navData => navData.isActive ? bigActiveItemStyle : bigItemStyle
  }
  else if (isMediumScreen) {
    activeStyle = navData => navData.isActive ? mediumActiveItemStyle : mediumItemStyle
  }
  else {
    activeStyle = navData => navData.isActive ? activeItemStyle : itemStyle
  }

  return (
    <nav
      className="navbar navbar-horizontal navbar-expand-lg navbar-dark bg-gradient-primary pt-1"
      style={isBigScreen ? {padding: "0.8rem"} : isMediumScreen ? {padding: "0.4rem"} : {}}
    >
      <div className="container px-4">
        <div className="d-flex">
          <Link className="navbar-brand" to="/">
            <img alt="flashtech-brand" src="brand/white.png"/>
          </Link>
        </div>
        <div className="navbar-nav">
          <ul className="nav ml-auto">
            <li className="nav-item mx-2">
              <Link className={activeClassName} style={activeStyle} to="/">
                <Item icon={faHome}>Dashboard</Item>
              </Link>
            </li>
            {user && user.permissions.includes("stats") &&
            <li className="nav-item mx-2">
              <Link className={activeClassName} style={activeStyle} to="/statistics">
                <Item icon={faChartBar}>Statistics</Item>
              </Link>
            </li>}
            {user && user.permissions.includes("predict") &&
            <li className="nav-item mx-2">
              <Link className={activeClassName} style={activeStyle} to="/forecast">
                <Item icon={faCalendarAlt}>Forecast</Item>
              </Link>
            </li>}
            {isSuperuser &&
            <li className="nav-item mx-2">
              <Link className={activeClassName} style={activeStyle} to="/sensors">
                <Item icon={faHdd}>Sensors</Item>
              </Link>
            </li>}
            {isSuperuser &&
            <li className="nav-item mx-2">
              <Link className={activeClassName} style={activeStyle} to="/logs">
                <Item icon={faListAlt}>Logs</Item>
              </Link>
            </li>}
            <li className="nav-item mx-2">
              <Link className={activeClassName} style={activeStyle} to="/profile">
                <Item icon={faUser}>Profile</Item>
              </Link>
            </li>
            <li className="nav-item mx-2">
              <a href="/login" className="nav-link" style={isBigScreen ? bigItemStyle : isMediumScreen ? mediumItemStyle : itemStyle} onClick={() => signout(()=> {})}>
                <Item icon={faSignOutAlt}>Logout</Item>
              </a>
            </li>
            <h5>version 0.5.1</h5>
          </ul>
        </div>
      </div>
    </nav>
  )
}
